<template>
    <v-container tag="section" class="mb-8">
        <v-row>
            <v-col class="py-sm-8 py-3">
                <h3 class="px-sm-9">{{ label }}</h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" class="py-sm-0 d-flex social-media">
                <v-row>
                    <v-col>
                        <a :href="socialData.facebookURL" v-if="socialData.facebookEnable" target="_blank">
                            <img src="@/assets/icons/fb-inverted.svg" alt="Facebook link" />
                        </a>
                    </v-col>
                    <v-col>
                        <a :href="socialData.instagramURL" v-if="socialData.instagramEnable" target="_blank">
                            <img src="@/assets/icons/in-inverted.svg" alt="Instagram link" />
                        </a>
                    </v-col>
                    <v-col>
                        <a :href="socialData.twitterURL" v-if="socialData.twitterEnable" target="_blank">
                            <img src="@/assets/icons/twitter-inverted.svg" alt="Twitter link" />
                        </a>
                    </v-col>
                    <v-col>
                        <a :href="socialData.youtubeURL" v-if="socialData.youtubeEnable" target="_blank">
                            <img src="@/assets/icons/Youtube-inverted.svg" alt="Youtube link" />
                        </a>
                    </v-col>
                    <v-col>
                        <a :href="socialData.linkedinURL" v-if="socialData.linkedinEnable" target="_blank">
                            <img src="@/assets/icons/Linkedin-inverted.svg" alt="LinkedIn link" />
                        </a>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: [
            'label'
        ],
        computed: {
            socialData() {
                return this.$store.getters.getSocialSettings
            }
        }
    }
</script>

<style lang="scss" scoped>
    .social-media {

        a {
            display: flex;
            justify-content: center;

            * {
                flex: 1 1 auto;
                min-height: 80px;
            }
        }
    }
</style>